import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AiHrAssistant from '../employeeUI/AiHrAssistant';

/**
 * Public marketing landing page shown to logged-out visitors at "/".
 *
 * The page itself lives as a self-contained static file at public/landing.html
 * and is mounted in an <iframe> so its styles/scripts are fully isolated from
 * the MUI app (no class-name or CSS-reset collisions). The "Employee login" /
 * "Admin console" buttons inside the iframe postMessage back to this component,
 * which routes the host app to the real login screens (/login, /admin).
 */
const LandingPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleMessage = (event) => {
      // Same-origin only: the iframe is served from our own public/ folder.
      if (event.origin !== window.location.origin) return;
      const data = event.data || {};
      if (data.type === 'hrp-landing-nav') {
        navigate(data.to === 'admin' ? '/admin' : '/login');
      }
    };
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [navigate]);

  return (
    <>
      <iframe
        title="HR Portal"
        src={`${process.env.PUBLIC_URL || ''}/landing.html`}
        style={{ border: 0, width: '100%', height: '100vh', display: 'block' }}
      />
      {process.env.REACT_APP_ENABLE_LUMA_AI === 'true' && <AiHrAssistant publicGuide />}
    </>
  );
};

export default LandingPage;
